import { cn, Input, Label, MultiSelect, PhoneInput, Textarea } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { type useEventFormDialogContents } from "../../../../hooks";

export interface LocationSectionProps
  extends Pick<ReturnType<typeof useEventFormDialogContents>, "form" | "locationOptions"> {}

export const LocationSection = ({ form, locationOptions }: LocationSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <form {...form.getFormProps()} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="event-locations" onClick={(e) => e.preventDefault()}>
          {t("Predefined Locations")}
        </Label>
        <MultiSelect
          {...form.getCustomFieldProps("locationIds")}
          id="event-locations"
          options={locationOptions}
          className="font-light w-full"
          clearSearchOnSelect={false}
          placeholder={t("Search predefined locations...")}
        />
      </div>
      <div
        className={cn(
          "transition-all overflow-hidden space-y-4",
          form.values.locationIds.length ? "h-0 opacity-0" : "h-[345px] opacity-1"
        )}
      >
        <div className="h-[1px] bg-gray-200 w-full" />
        <p className="text-xs text-muted-foreground font-light">{t("Or enter custom location details below.")}</p>
        <div className="space-y-2">
          <Label htmlFor="location-name">{t("Location name")}</Label>
          <Input
            {...form.getFieldProps("locationName")}
            placeholder={t("e.g. Suite 4B, 123 Main St")}
            id="location-name"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="location-url">{t("Website URL")}</Label>
          <Input {...form.getFieldProps("locationURL")} placeholder={t("https://...")} id="location-url" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="location-phone">{t("Phone")}</Label>
          <PhoneInput
            {...form.getCustomFieldProps("locationPhone")}
            placeholder={t("+1 (555) 000-0000")}
            id="location-phone"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="location-notes">{t("Notes")}</Label>
          <Textarea
            {...form.getCustomFieldProps("locationNotes")}
            placeholder={t("Parking instructions, floor, etc")}
            id="location-notes"
          />
        </div>
      </div>
    </form>
  );
};
